// extracted by mini-css-extract-plugin
export var container = "product-card-module--container--2_nU9";
export var cardBody = "product-card-module--cardBody--3zQpm";
export var title = "product-card-module--title--1XrG3";
export var price = "product-card-module--price--hLGvn";